import { TypeEnum } from "@/types/types";
import { useEffect, useRef, useState } from "react";
import styles from "../page-searchbar.module.css";
import { MdApartment, MdBusiness, MdHouse, MdLandscape } from "react-icons/md";
import { useDropdownPosition } from "@/hooks/use-dropdown-position";
import SelectorComponentListItem from "@/components/searchbars/selector-component-list-item";
import { BsHousesFill } from "react-icons/bs";
import { useSavedListingsStore } from "../../useSavedListingsStore";
import { IoIosArrowDown } from "react-icons/io";

export default function TypeSelector({
  t,
  type,
  refetchState,
  fullWidth,
}: {
  t: any;
  type: TypeEnum;
  refetchState: () => Promise<void>;
  fullWidth?: boolean;
}) {
  const [isTypeOpen, setIsTypeOpen] = useState(false);
  const typeListRef = useRef<HTMLDivElement>(null);
  const setType = useSavedListingsStore((state) => state.setType);
  const typeListStyles = useDropdownPosition(typeListRef, isTypeOpen, {
    customWidth: 240, // px
    fullWidth: fullWidth,
  });

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        typeListRef.current &&
        !typeListRef.current.contains(event.target as Node)
      ) {
        setIsTypeOpen(false); //this will close it
      }
    };
    if (isTypeOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isTypeOpen]);

  return (
    <div
      className={`${styles.itemWrapper} ${fullWidth ? styles.fullWidth : ""}`}
      ref={typeListRef}
    >
      <button
        onClick={(e) => {
          e.preventDefault();
          setIsTypeOpen(!isTypeOpen);
        }}
        className={styles.item}
      >
        <div className={styles.textWrapper}>
          <span className={styles.title}>
            {t("savedAndMyListings.typeLabel", { default: "Type" })}
          </span>
          <span
            className={type !== TypeEnum.DEFAULT ? styles.hasSelection : ""}
          >
            {t(type)}
          </span>
        </div>
        <IoIosArrowDown className={styles.dropdownIcon} />
      </button>
      {isTypeOpen && typeListStyles.top && (
        <ul className={`${styles.selectionList}`} style={typeListStyles}>
          <SelectorComponentListItem
            text={t("apartment-house")}
            icon={<BsHousesFill />}
            isActive={type === TypeEnum.APARTMENT_HOUSE}
            onClick={async () => {
              setType(TypeEnum.APARTMENT_HOUSE);
              setIsTypeOpen(false);
              await refetchState();
            }}
          />
          <SelectorComponentListItem
            text={t("apartment")}
            icon={<MdApartment />}
            isActive={type === TypeEnum.APARTMENT}
            onClick={async () => {
              setType(TypeEnum.APARTMENT);
              setIsTypeOpen(false);
              await refetchState();
            }}
          />
          <SelectorComponentListItem
            text={t("house")}
            icon={<MdHouse />}
            isActive={type === TypeEnum.HOUSE}
            onClick={async () => {
              setType(TypeEnum.HOUSE);
              setIsTypeOpen(false);
              await refetchState();
            }}
          />
          <SelectorComponentListItem
            text={t("land")}
            icon={<MdLandscape />}
            isActive={type === TypeEnum.LAND}
            onClick={async () => {
              setType(TypeEnum.LAND);
              setIsTypeOpen(false);
              await refetchState();
            }}
          />
          <SelectorComponentListItem
            text={t("office")}
            icon={<MdBusiness />}
            isActive={type === TypeEnum.OFFICE}
            onClick={async () => {
              setType(TypeEnum.OFFICE);
              setIsTypeOpen(false);
              await refetchState();
            }}
          />
          <SelectorComponentListItem
            text={t("any")}
            icon={""}
            isActive={type === TypeEnum.DEFAULT}
            onClick={async () => {
              setType(TypeEnum.DEFAULT);
              setIsTypeOpen(false);
              await refetchState();
            }}
          />
        </ul>
      )}
    </div>
  );
}
